import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
	name: 'currencyFormat'
})

export class CurrencyFormatPipe extends CurrencyPipe
{
	transform(value: any,
	          currencyCode?: string,
	          symbolDisplay?: boolean,
	          digits?: string,
	          decimalDelimiter = ',',
	          chunkDelimiter = '.'): string | null
	{
		let tmp = super.transform(value, currencyCode, symbolDisplay, digits);
		tmp = tmp.replace(/\,(?=\d\d\d)/g, chunkDelimiter);
		tmp = tmp.replace(/\.(?=\d\d$)/g, decimalDelimiter);
		return tmp;
	}
}



// WEBPACK FOOTER //
// ./src/app/pipes/currency-format.pipe.ts